import { REACT_APP_API_BASE_URL } from "../../utils/constant";
import {
  getAccessTokenString,
  setAccessToken,
  clearAccessToken,
} from "../../auth";
import { refreshAuth } from "../../refresh";

let refreshing = null;

async function doRefreshAndSet(baseURL) {
  if (refreshing) return refreshing;
  refreshing = (async () => {
    try {
      const tokenObj = await refreshAuth(baseURL);
      setAccessToken(tokenObj, baseURL);
      return tokenObj;
    } finally {
      refreshing = null;
    }
  })();
  return refreshing;
}
export async function apiFetch(
  url,
  method = "GET",
  data = null,
  headers = {},
  baseURL = REACT_APP_API_BASE_URL || "",
  attemptsLeft = 1,
  opts = {}
) {
  const { skipAuth = false} = opts;
  const finalUrl = baseURL + url;
  try {
    const token = getAccessTokenString();
    let config = {
        method,
        headers: {
          ...headers,
          ...(token && !skipAuth ? { Authorization: `Bearer ${token}` } : {}),
        },
        ...(data ? { body: JSON.stringify(data) } : {}),
         credentials: 'include',
      };

    const res = await fetch(finalUrl, config);
    const ct = res.headers.get("content-type") || "";
    const responseData = ct.includes("application/json")
      ? await res.json()
      : await res.text();
    return responseData;
  } catch (err) {
    if (err && err.status === 401 && attemptsLeft > 0) {
      try {
        await doRefreshAndSet(baseURL); 
        return await apiFetch(
          url,
          method,
          data,
          headers,
          baseURL,
          attemptsLeft - 1
        );
      } catch (refreshErr) {
        clearAccessToken();
        throw refreshErr;
      }
    }
    throw err;
  }
}
